import Dialog from './Dialog.js';

class CreateAccountDialog extends Dialog {
    static create({id, env}) {
        return new CreateAccountDialog({id, decorator: env.getDecorator()});
    }

    static getEulaLink() {
        return $('#create-account-dialog').find('.eula-link');
    }

    constructor({id, decorator}) {
        super({id, autoInitEvents: false});

        this.emailField = decorator.errorAndEnterKeyPress(this.find('.email-input'));
        this.passwordField1 = decorator.errorAndEnterKeyPress(this.find('.password-1-input'));
        this.passwordField2 = decorator.errorAndEnterKeyPress(this.find('.password-2-input'));
        this.eulaCheckField = this.find('.eula-wrapper');
        this.eulaCheckbox = decorator.checkbox(this.find('.eula-checkbox'));
        this.eulaLink = decorator.preventDefaultClick(this.find('.eula-link'));
        this.signInLink = decorator.preventDefaultClick(this.find('.sign-in-link'));
        this.submitButton = decorator.spinnerButton(this.find('.create-account-button'));

        this.initEvents();
    }

    initEvents() {
        super.initEvents();

        this.emailField.on('enterKeyPress', () => this.onSubmitGesture());
        this.passwordField1.on('enterKeyPress', () => this.onSubmitGesture());
        this.passwordField2.on('enterKeyPress', () => this.onSubmitGesture());
        this.eulaLink.click(() => this.maybeTrigger('eulaLink:click'));
        this.signInLink.click(() => this.maybeTrigger('signInLink:click'));
        this.submitButton.click(() => this.onSubmitGesture());
    }

    addDifferentPasswordsError() {
        this.passwordField2.addError('The passwords you provided are not the same.');
        this.passwordField2.focus();
    }

    addEulaError() {
        $('<div/>').html('You must accept the terms of the EULA to create a new account.')
            .addClass('error field-error field-error-arrow-middle')
            .attr('id', 'eula-checkbox-error')
            .attr('role', 'alert')
            .attr('aria-live', 'assertive')
            .appendTo(this.eulaCheckField.find('.error-wrapper'));

        this.eulaCheckField.find('input')
            .attr('aria-invalid', 'true')
            .attr('aria-errormessage', 'eula-checkbox-error');

        this.performLayout();
    }

    addInvalidEmailError() {
        this.emailField.addError('The email address you have provided does not appear to be valid.');
        this.focusEmailField();
    }

    addInvalidPasswordError() {
        this.passwordField1.addError('The password you provided is not valid. Passwords must contain at least 6 characters and must not contain spaces.');
        this.passwordField1.focus();
    }

    focusEmailField() {
        this.emailField.focus();
    }

    getEmail() {
        return this.getState().email;
    }

    getState() {
        var email = this.emailField.val(),
            password1 = this.passwordField1.val(),
            password2 = this.passwordField2.val(),
            eulaChecked = this.eulaCheckbox.checked();

        return {email, password1, password2, eulaChecked};
    }

    onSubmitGesture() {
        this.maybeTrigger('submitGesture');
    }

    reset() {
        this.clearErrors();
        this.setEmail('');
        this.passwordField1.val('');
        this.passwordField2.val('');
        this.eulaCheckbox.uncheck();
    }

    setEmail(email) {
        this.emailField.val(email);
    }

    setEulaCheckFieldVisible(visible) {
        this.eulaCheckField.toggle(visible);
        return this;
    }

    setSubmitting(submitting) {
        this.setEventsEnabled(!submitting);
        this.submitButton.toggleSpinner(submitting);
    }
}

export default CreateAccountDialog;
